import { spacing, colors, layouts, devices } from '../../config/theme';
import {
  asPx,
  calc100,
  width100,
  height100,
  padding0,
  widthHeight100,
  flexRowSpaceBetween,
  flexColSpaceBetween,
  flexColStart,
  flexCenter,
  flexStart,
  pointer,
  flexEnd,
  scrollY
} from '../../utils/jss-utils';

const style = {};

style.app = {
  ...scrollY,
  flexWrap: 'wrap',
  backgroundColor: colors.white,
  paddingLeft: asPx(spacing.outterContent),
  paddingRight: asPx(spacing.outterContent)
};

style.app[devices.mobile] = {
  // ...height100,
  ...flexRowSpaceBetween,
  paddingLeft: asPx(spacing.outterContent / 2),
  paddingRight: asPx(spacing.outterContent / 2),
  width: calc100(spacing.outterContent)
};

style.app[devices.desktop] = {
  ...flexRowSpaceBetween,
  width: calc100(spacing.outterBorder + spacing.outterContent * 2),
  minHeight: calc100(spacing.outterBorder),
  maxHeight: calc100(spacing.outterBorder),
  ...scrollY
};

style.header = {
  ...flexRowSpaceBetween,
  flexBasis: '100%',
  minHeight: asPx(layouts.header.height),
  maxHeight: asPx(layouts.header.height)
};

style.headerRight = {
  ...flexEnd,
  width: calc100(layouts.sidebar.width + spacing.outterContent)
};

style.headerRight[devices.desktop] = {
  // borderBottom: `2px solid ${colors.lightGray}`
  // use progressbar instead
};

style.body = {
  ...flexStart,
  flexGrow: 2,
  minHeight: '100%'
};

style.content = {
  paddingLeft: asPx(spacing.outterContent),
  paddingRight: asPx(spacing.outterContent),
  ...width100
};

style.content[devices.mobile] = { ...padding0 };

style.footer = {
  minHeight: asPx(layouts.footer.height),
  maxHeight: asPx(layouts.footer.height),
  alignSelf: 'flex-start'
};

style.authBrandContainer = {
  display: 'flex',
  alignItems: 'center'
};
style.authBrandContainer[devices.mobile] = {
  height: layouts.desktopHeader.height,
  width: '100%',
  // width: '100vw',
  // position: 'fixed',
  // top: '0',
  backgroundColor: colors.white,
  backgroundImage:
    'linear-gradient(-45deg, #f3f4ee, #a5d5d5, #e9e1d6, #a074bf, #775f99)',
  backgroundSize: '600% 600%',
  animation: 'Gradient 25s ease infinite'
};
style.authMainContainer = {
  backgroundColor: colors.white
};

style.authMainContainer[devices.mobile] = {
  height: calc100(layouts.desktopHeader.height),
  ...width100,
  // height: 'calc100(100vh - 90px)',
  // padding: asPx(spacing.outterContent / 2),
  paddingTop: '0 !important'
};

style.authMainContainer[devices.desktop] = {
  opacity: '.83'
};

style.auth = {
  ...widthHeight100,
  ...flexCenter
};

style.auth[devices.desktop] = {
  backgroundImage:
    'linear-gradient(-45deg, #f3f4ee, #a5d5d5, #e9e1d6, #a074bf, #775f99)',
  backgroundSize: '600% 600%',
  animation: 'Gradient 25s ease infinite',
  position: 'fixed',
  top: 0,
  left: 0,
  overflowY: 'scroll',
  // '@media only screen and (max-height: 500px)': {
  //   paddingTop: '100px !important'
  // },
  '& img': {
    ...pointer,
    position: 'absolute',
    height: '55px',
    paddingTop: asPx(spacing.outterContent / 2),
    paddingLeft: asPx(spacing.outterContent / 2),
    top: '45px', // add padding of fullscreen app
    left: '45px'
  }
};

style.auth[devices.mobile] = {
  // backgroundColor: colors.white
  ...flexColStart,

  '& img': {
    ...pointer,
    position: 'absolute',
    height: '25px'
  }
};

export default style;
